// Angular
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

// Ngx
import { ToastrService } from 'ngx-toastr';

// RxJS
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Services
import { AuthenticationService } from 'app/auth/service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _router: Router,
    private _toastrService: ToastrService,
    private _authenticationService: AuthenticationService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if ([401, 403].indexOf(err.status) !== -1) {
          // ? Can also logout and reload if needed
          this._authenticationService.logout();
          // location.reload();

          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          this._router.navigate(['/pages/miscellaneous/not-authorized']);

          // Show toast?
          let message = '';

          if (err.status === 401) {
            if (err.error.topcode === -1) {
              message = 'Contraseña incorrecta.';
            }

            if (err.error.topcode === 0) {
              message = 'No ingreso su usuario y/o contraseña en la solicitud.';
            }

            if (err.error.topcode === 1) {
              message = 'No ingreso un usuario válido.';
            }

            if (err.error.topcode === 4) {
              message = 'No se encontro el usuario ingresado.';
            }

            if (err.error.topcode === 5) {
              message = 'No se encontro el dispositivo ingresado.';
            }

            if (err.error.topcode === 6) {
              message = 'Token JWT inválido.';
            }
          }

          if (err.status === 403) {
            if (err.error.topcode === -1) {
              message = 'No tiene acceso a los archivos del centro seleccionado.';
            }

            if (err.error.topcode === 0) {
              message = 'Su cuenta no tiene los permisos suficientes.';
            }

            if (err.error.topcode === 1) {
              message = 'Tu cuenta está deshabilitada';
            }
          }

          if (message !== '') {
            this._toastrService.error(message, 'Error de autenticación 🔒', {
              toastClass: 'toast ngx-toastr',
              closeButton: true,
            });
          }
        }
        // throwError
        return throwError(err);
      })
    );
  }
}
